/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';

import getTypedDataset from '@zr/utilities/dataset';

import { I18NLoader } from './I18NLoader';
import { ImportTranslationsFn, ZRGlobal } from './d';
import { PageContext } from './PageContext';
import renderMicrofrontEnd from './bootstrapperMicrofrontend';

declare const zr: ZRGlobal;

/**
 * Renders a React component into the DOM in the supplied container.
 *
 * @param {React.Component} Component React component
 * @param {HTMLElement} container DOM element
 * @param {import('./d').ImportTranslationsFn} importTranslation
 * @param {Object} [props] Additional props to add to the React component
 * @param {string} microfrontendName Optional microfrontend name
 */


export default function render<TProps>(
  Component: (
    React.FC<TProps> | React.ComponentClass | React.DetailedReactHTMLElement<any, any>
  ) & { $$typeof?: symbol },
  container: HTMLElement | null,
  importTranslation: ImportTranslationsFn,
  props?: TProps,
  microfrontendName?: string,
): void {
  if (container === null || !container) {
    throw new Error('Container element is required.');
  }

  if (microfrontendName) {
    renderMicrofrontEnd(Component, container, importTranslation, microfrontendName, props);
    return;
  }

  // Call this to properly hide your application from assistive screen readers
  // and other assistive technologies while the modal is open.
  (ReactModal as { setAppElement(container: HTMLElement): void }).setAppElement(container);

  const dataset = getTypedDataset(container.dataset);

  const pageVariables = zr?.page?.model || {};

  const allProps = { ...dataset, ...props, page: pageVariables };

  // create or clone React element, adding page variables and container dataset
  // <Component {...dataset} {...props} page={pageVariables} />
  let element = Component.$$typeof === Symbol.for('react.element')
    ? React.cloneElement(
      Component as React.DetailedReactHTMLElement<any, any>,
      allProps,
    )
    : React.createElement(Component as React.FC<any> | React.ComponentClass<any>, allProps);

  try {
    // wrap component with I18NLoader component
    // <I18NLoader projectPrefix='WEB_JOBS_'>
    //   <Component {...dataset} {...props}, page={pageVariables} />
    // </I18NLoader>
    element = React.createElement(I18NLoader, { importTranslation }, element) as unknown as (typeof element);

    // wrap component with PageContext Provider
    // <PageContext.Provider value={zr}>
    //   {children}
    // </PageContext.Provider>
    element = React.createElement(PageContext.Provider, { value: zr }, element);
  } catch (error) {
    console.error((error as Error).message); // eslint-disable-line no-console
  }

  ReactDOM.render(element, container);
}
